/** Join conditional className parts, dropping falsy ones. Tiny clsx — no dependency. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
